import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setPostUpdateTournament = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_UPDATE_TOURNAMENT
            });
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostUpdateTournament as SetPostUpdateTournament
}